import React from "react";
import { getActiveSale } from "../lib/promo";
import { Tag } from "lucide-react";

// Inline SALE pill — show next to product price when a promotion is active.
// size: "sm" | "md"
export function SalePill({ product, size = "sm", showCustomLabel = true }) {
  const sale = getActiveSale(product);
  if (!sale) return null;
  const sm = size === "sm";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-black tracking-wide bg-gradient-to-r from-rose-500 to-pink-500 text-white shadow-[0_0_18px_rgba(244,63,94,0.45)] ${
        sm ? "px-2 py-[3px] text-[10px]" : "px-2.5 py-1 text-xs"
      }`}
      data-testid={`sale-pill-${product.product_id}`}
    >
      <Tag className={sm ? "w-2.5 h-2.5" : "w-3 h-3"} />
      {sale.percent_off > 0 ? `-${sale.percent_off}%` : "SALE"}
      {showCustomLabel && sale.label ? <span className="opacity-90 font-bold normal-case ml-0.5">· {sale.label}</span> : null}
    </span>
  );
}

// Price block — shows sale price + strikethrough original when a sale is active.
// Otherwise just shows the regular price.
export function PriceBlock({ product, className = "", testid }) {
  const sale = getActiveSale(product);
  const price = Number(product.price || 0);
  if (sale) {
    return (
      <span className={`inline-flex items-baseline gap-1.5 ${className}`} data-testid={testid}>
        <span className="font-black">${sale.sale_price.toFixed(2)}</span>
        <span className="text-[0.75em] text-zinc-400 line-through opacity-80">${price.toFixed(2)}</span>
      </span>
    );
  }
  return (
    <span className={`font-black ${className}`} data-testid={testid}>${price.toFixed(2)}</span>
  );
}
